import { createFileRoute } from "@tanstack/solid-router";
import { seo } from "~/utils/seo";

export const Route = createFileRoute("/_main/terms")({
  head: () => ({
    meta: seo({
      title: "Terms and Conditions | ileckie.com",
      description: "Website terms and conditions of use for ileckie.com.",
      path: "/terms",
    }),
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <main class="flex min-h-screen flex-col bg-[#050308] selection:bg-indigo-500/30 selection:text-white">
      <div class="mx-auto w-full max-w-4xl px-6 py-12 md:py-16 lg:py-20">
        <h1 class="mb-8 text-4xl font-bold text-white">
          Website Terms and Conditions of Use
        </h1>

        <h2 class="mb-4 mt-8 text-2xl font-semibold text-white">1. Terms</h2>
        <p class="mb-6 leading-relaxed text-white/60">
          By accessing this Website, accessible from https://ileckie.com, you
          are agreeing to be bound by these Website Terms and Conditions of Use
          and agree that you are responsible for the agreement with any
          applicable local laws. If you disagree with any of these terms, you
          are prohibited from accessing this site. The materials contained in
          this Website are protected by copyright and trade mark law.
        </p>

        <h2 class="mb-4 mt-8 text-2xl font-semibold text-white">
          2. Use License
        </h2>
        <p class="mb-4 leading-relaxed text-white/60">
          Permission is granted to temporarily download one copy of the
          materials on ileckie.com&apos;s Website for personal, non-commercial
          transitory viewing only. This is the grant of a license, not a
          transfer of title, and under this license you may not:
        </p>
        <ul class="mb-6 ml-4 space-y-2 text-white/60">
          <li>modify or copy the materials;</li>
          <li>
            use the materials for any commercial purpose or for any public
            display;
          </li>
          <li>
            attempt to reverse engineer any software contained on
            ileckie.com&apos;s Website;
          </li>
          <li>
            remove any copyright or other proprietary notations from the
            materials; or
          </li>
          <li>
            transferring the materials to another person or &quot;mirror&quot;
            the materials on any other server.
          </li>
        </ul>
        <p class="mb-6 leading-relaxed text-white/60">
          This will let ileckie.com to terminate upon violations of any of these
          restrictions. Upon termination, your viewing right will also be
          terminated and you should destroy any downloaded materials in your
          possession whether it is printed or electronic format.
        </p>

        <h2 class="mb-4 mt-8 text-2xl font-semibold text-white">
          3. Disclaimer
        </h2>
        <p class="mb-6 leading-relaxed text-white/60">
          All the materials on ileckie.com&apos;s Website are provided &quot;as
          is&quot;. ileckie.com makes no warranties, may it be expressed or
          implied, therefore negates all other warranties. Furthermore,
          ileckie.com does not make any representations concerning the accuracy
          or reliability of the use of the materials on its Website or otherwise
          relating to such materials or any sites linked to this Website.
        </p>

        <h2 class="mb-4 mt-8 text-2xl font-semibold text-white">
          4. Limitations
        </h2>
        <p class="mb-6 leading-relaxed text-white/60">
          ileckie.com or its suppliers will not be hold accountable for any
          damages that will arise with the use or inability to use the materials
          on ileckie.com&apos;s Website, even if ileckie.com or an authorized
          representative of this Website has been notified, orally or written,
          of the possibility of such damage. Some jurisdiction does not allow
          limitations on implied warranties or limitations of liability for
          incidental damages, these limitations may not apply to you.
        </p>

        <h2 class="mb-4 mt-8 text-2xl font-semibold text-white">
          5. Revisions and Errata
        </h2>
        <p class="mb-6 leading-relaxed text-white/60">
          The materials appearing on ileckie.com&apos;s Website may include
          technical, typographical, or photographic errors. ileckie.com will not
          promise that any of the materials in this Website are accurate,
          complete, or current. ileckie.com may change the materials contained
          on its Website at any time without notice. ileckie.com does not make
          any commitment to update the materials.
        </p>

        <h2 class="mb-4 mt-8 text-2xl font-semibold text-white">6. Links</h2>
        <p class="mb-6 leading-relaxed text-white/60">
          ileckie.com has not reviewed all of the sites linked to its Website
          and is not responsible for the contents of any such linked site. The
          presence of any link does not imply endorsement by ileckie.com of the
          site. The use of any linked website is at the user&apos;s own risk.
        </p>

        <h2 class="mb-4 mt-8 text-2xl font-semibold text-white">
          7. Site Terms of Use Modifications
        </h2>
        <p class="mb-6 leading-relaxed text-white/60">
          ileckie.com may revise these Terms of Use for its Website at any time
          without prior notice. By using this Website, you are agreeing to be
          bound by the current version of these Terms and Conditions of Use.
        </p>

        <h2 class="mb-4 mt-8 text-2xl font-semibold text-white">
          8. Your Privacy
        </h2>
        <p class="mb-6 leading-relaxed text-white/60">
          Please read our{" "}
          <a href="/privacy" class="text-indigo-400 hover:underline">
            Privacy Policy
          </a>
          .
        </p>

        <h2 class="mb-4 mt-8 text-2xl font-semibold text-white">
          9. Governing Law
        </h2>
        <p class="mb-6 leading-relaxed text-white/60">
          Any claim related to ileckie.com&apos;s Website shall be governed by
          the laws of us without regards to its conflict of law provisions.
        </p>

        <h2 class="mb-4 mt-8 text-2xl font-semibold text-white">
          10. Non-Liability
        </h2>
        <p class="mb-6 leading-relaxed text-white/60">
          ileckie.com does not assume any liability or responsibility for the
          actions, conduct, or outcomes resulting from user-created content.
          Users engage in such activities at their own risk, and ileckie.com
          shall not be held liable for any damages, losses, or liabilities
          arising from such activities.
        </p>

        <h2 class="mb-4 mt-8 text-2xl font-semibold text-white">
          11. Compliance with Laws
        </h2>
        <p class="mb-6 leading-relaxed text-white/60">
          Users are solely responsible for ensuring that their activities comply
          with all applicable laws, regulations, and contractual obligations.
          This includes but is not limited to privacy laws, intellectual
          property laws, and any other relevant legal requirements.
        </p>

        <h2 class="mb-4 mt-8 text-2xl font-semibold text-white">
          12. Indemnification
        </h2>
        <p class="mb-6 leading-relaxed text-white/60">
          Users agree to indemnify and hold ileckie.com, its owners, employees,
          and affiliates harmless from any claims, damages, losses, or
          liabilities arising out of or related to their activities or any
          violation of the terms and conditions. This includes legal fees and
          expenses incurred in defending against such claims.
        </p>

        <h2 class="mb-4 mt-8 text-2xl font-semibold text-white">
          13. Content Ownership
        </h2>
        <p class="mb-6 leading-relaxed text-white/60">
          Any content, materials, or information shared on ileckie.com are the
          sole responsibility of the users. ileckie.com does not claim ownership
          over user-generated content and assumes no responsibility for its
          accuracy, legality, or compliance. Users retain all ownership rights
          to their content.
        </p>

        <h2 class="mb-4 mt-8 text-2xl font-semibold text-white">
          14. Modification or Termination of Services
        </h2>
        <p class="mb-6 leading-relaxed text-white/60">
          ileckie.com reserves the right to modify, suspend, or terminate the
          services offered at any time without prior notice. ileckie.com shall
          not be liable to users or any third party for any modifications,
          suspensions, or terminations of services.
        </p>
      </div>
    </main>
  );
}
